import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { errorMessage } from '../../actions/internal';
import { useCommunication } from '../../hooks/useCommunication';
import CardSelector from './CardSelector';
import ProgramContentSelector from './ProgramContentSelector';

const MessagesPanel = ({
  conversationId,
  onSendMessage,
  player,
  errorMessage,
  isSending = false,
}) => {
  const { newMessageModal } = useCommunication();

  const [message, setMessage] = useState('');
  const [cards, setCards] = useState([]);
  const [programContentEntries, setProgramContentEntries] = useState([]);

  const onModalClose = (keepInput) => {
    if (keepInput) {
      return;
    }

    setMessage('');
    setCards([]);
    setProgramContentEntries([]);
  }

  const onSendClick = () => {
    if (!message.trim()) {
      return;
    }

    onSendMessage(conversationId, {
      message,
      cardIds: cards.map(c => c.value),
      programContentEntryIds: programContentEntries.map(e => e.value),
    });

    setMessage('');
    setCards([]);
    setProgramContentEntries([]);
  }

  const onTranslateClick = () => {
    if (!message.trim()) {
      return;
    }

    newMessageModal({
      conversationId,
      player,
      message,
      originCards: cards,
      originProgramContentEntries: programContentEntries,
      forcePreview: true,
      onModalClose: onModalClose,
    });
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onSendClick();
    }
  };

  return(
    <div className="o-communication__chat-panel-message-operations">
      <div className="o-communication__chat-panel-message-operations__input-container">
        <input
          type="text"
          className="o-communication__chat-panel-message-operations__message-input"
          placeholder="Enter message..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={handleKeyDown}
        />
      </div>
      <div className="o-communication__chat-panel-message-operations__input-container">
        <CardSelector
          value={cards}
          onChange={(value) => { setCards(value) }}
          isDisabled={isSending || !isEmpty(programContentEntries)}
          onErrorMessage={errorMessage}/>
        <ProgramContentSelector
          value={programContentEntries}
          onChange={(value) => { setProgramContentEntries(value) }}
          isDisabled={isSending || !isEmpty(cards)}
          onErrorMessage={errorMessage}
          className='u-margin-left--small'/>
      </div>
      <div className="o-communication__chat-panel-message-operations__input-container o-communication__chat-panel-message-operations__input-container--buttons margin-top-0 margin-bottom-1">
        <button
          className="o-sp-button o-sp-button--update o-sp-button--primary o-communication__chat-panel-message-operations__button"
          onClick={onTranslateClick}
          disabled={!message.trim()}
        >Translate</button>
        <button
          className="o-sp-button o-sp-button--update o-sp-button--primary o-communication__chat-panel-message-operations__button u-margin-left--small"
          onClick={onSendClick}
          disabled={!message.trim()}
        >Send</button>
      </div>
    </div>
  )
};

MessagesPanel.propTypes = {
  conversationId: PropTypes.number.isRequired,
  player: PropTypes.shape({
    playerId: PropTypes.number,
    playerName: PropTypes.string,
    accountName: PropTypes.string,
  }).isRequired,
  onSendMessage: PropTypes.func.isRequired,
  isSending: PropTypes.bool,
  errorMessage: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  isSending: state.communication?.isSending,
});

export default connect(mapStateToProps, {
  errorMessage,
})(MessagesPanel);
